var colors = [
    '#ffffff', '#feeaef', '#fdf0da', '#fdfecf', '#e9fdd0', '#e0f6fe', '#fae5fc',
    '#e2e2e2', '#fde2e1', '#f4e5da', '#efeddb', '#ceffcf', '#dfebfe', '#dddbfe',
];
var textColors = [
    '#999999', '#ee3db9', '#ff5e2f', '#d07f00', '#638800', '#00799c', '#d041e1',
    '#515151', '#eb3639', '#c55a11', '#7f6000', '#007d42', '#175ceb', '#a419d3'
];
export var defaultColors = [
    '#ffffff', '#e9e9e9', '#fefec0', '#dbffc7', '#c1fee8', '#c9fdfe',
    '#d5eafe', '#d6d6fe', '#e6d2fb', '#f5cff5', '#f3d3e2', '#f5d4d3',
];
export var defaultConfig = colors.map(function (color, index) { return ({
    color: color,
    textColor: textColors[index]
}); });
